import styled, { css } from "styled-components"
import breakpoint from "styled-components-breakpoint"

export const Fieldset = styled.div`
  border-bottom: 1px solid #dddddd;
  padding-bottom: 2rem;

  &:last-child {
    border-bottom: none;
    padding-bottom: 0;
  }

  ${({ video }) =>
    video &&
    css`
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      gap: 2rem;

      ${breakpoint("tablet")`
        flex-direction: row;
      `}
    `}
`

export const CustomFlex = styled.div`
  ${({ header }) =>
    header &&
    css`
      ${breakpoint("tablet")`
        flex-direction: row;
      `}

      display: flex;
      justify-content: space-between;
      gap: 2rem;
      flex-direction: column-reverse;
    `}
`

export const VideoContainer = styled.div`
  flex-shrink: 0;
  overflow: hidden;
  margin: 0 auto;

  ${breakpoint("tablet")`
    margin: 0;
  `}
`

export const Div = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;

  ${({ profileLayout }) =>
    profileLayout === "split" &&
    css`
      flex: 1;
      box-sizing: border-box;
    `}
  ${({ profileLayout }) =>
    profileLayout === "horizontal" &&
    css`
      display: grid;
      align-items: start;
      gap: 1.5rem;
      grid-template: auto / 1fr;

      ${breakpoint("tablet")`
        grid-template: auto / 1fr 1fr;
      `}
      ${breakpoint("desktop")`
        grid-template: auto / 1fr 1fr 1fr 1fr;
      `}
    `}
`

export const Image = styled.img`
  max-width: 100%;
  width: 100%;
  height: auto;
  border-radius: 8px;
`
